import { BasicRequest } from "./basicRequest";

export class PreviewValidationRequest extends BasicRequest{
    public validationDefinitionId!:number;

    constructor(){
        super();
    }
}